import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MaterialReceiving from './materialReceiving';
import {
  getChallansList
} from 'services/redux/installation/hardwareInstall/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import hardwareInstallReducer from "../../../services/redux/installation/hardwareInstall/reducer";

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  challansList: state.hardwareInstallReducer.tsList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getChallansList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialReceiving);
